// frontend/src/app/claim-annotator/ports/user-context.port.ts
import { InjectionToken, Signal } from '@angular/core';

export interface UserContext {
  readonly currentUserLabel: Signal<string>;
}

export const USER_CONTEXT = new InjectionToken<UserContext>('USER_CONTEXT');
